import TagManager from 'react-gtm-module'

export function sendEvent({ payload }) {
  TagManager.dataLayer({
    dataLayer: payload,
  })
}

export default null
